import {
    CLOSE_BALANCE_MODAL,
    OPEN_BALANCE_MODAL,
    GET_BALANCE_DATA,
    ADD_TRANSACTION,
    RESET_BALANCE,
    CHANGE_DISTRIBUTOR,
    GET_TRANSACTIONS,
    GET_DAILY_TRANSACTIONS,
    SELECT_TRANSACTION,
    DELETE_TRANSACTION,
    GET_MATERIAL_MEANS_REPORT,
    GET_SALARY_TRANSACTIONS,
    ADD_SALARY_TRANSACTIONS,
    DELETE_SALARY_TRANSACTIONS
} from './balance.actionsTypes';
import  { ACTION_TYPES } from '../../config/constants';

export default function balanceDetails(state = { salaryTransactions: []}, action) {
    let newState = Object.assign({}, state);
    switch (action.type) {
        case OPEN_BALANCE_MODAL:
            return {
                ...newState,
                show: true,
                distributor: action.distributor
            };
        case CLOSE_BALANCE_MODAL:
            return {
                ...newState,
                show: false
            };
        case GET_BALANCE_DATA:
            return {
                ...newState,
                balanceData: action.balanceData
            };
        case GET_TRANSACTIONS:
            return {
                ...newState,
                combinedTransactions: action.combinedTransactions,
                rest: action.rest,
                distributorId: action.distributorId
            };
        case GET_DAILY_TRANSACTIONS:
            return {
                ...newState,
                dailyTransactions: action.dailyTransactions
            }
        case GET_SALARY_TRANSACTIONS:
            return {
                ...newState,
                salaryTransactions: {
                    ...newState.salaryTransactions,
                    [action.data.key]: action.data.transactions
                }
            }
        case ADD_SALARY_TRANSACTIONS:
            return {
                ...newState,
                salaryTransactions: {
                    ...newState.salaryTransactions,
                    [action.data.key]: [
                        ...newState.salaryTransactions[action.data.key],
                        action.data.transaction
                    ] 
                }
            }
        case DELETE_SALARY_TRANSACTIONS:
            return {
                ...newState,
                salaryTransactions:{
                    ...newState.salaryTransactions,
                    [action.data.key] :newState.salaryTransactions[action.data.key].filter(e => e._id != action.data.transactionId)
                }
            }
        case ADD_TRANSACTION:
            const transactions = newState.transactions || [];
            transactions.push(action.transaction);
            return {
                ...newState,
                transactions,
                rest: action.rest
            };
        case CHANGE_DISTRIBUTOR:
            return {
                ...newState,
                activeDistributor: action.activeDistributor,
            };
        case SELECT_TRANSACTION:
            return {
                ...newState,
                selectedTransaction: action.selectedTransaction
            }
        case DELETE_TRANSACTION:
            return {
                ...newState
            }
        case RESET_BALANCE:
        case ACTION_TYPES.LOGOUT_SUCCESS:
            return {
                ...newState,
                transactions: [],
                distributorId: null,
                rest:''
            };
        case GET_MATERIAL_MEANS_REPORT:
            return {
                ...newState,
                materialMeansReport: action.materialMeansReport
            }
        default:
            return newState;
    }
}

